export default {"src":"/_next/static/media/logo.e09a8f95.svg","height":38,"width":141,"blurWidth":0,"blurHeight":0};